import { render } from "./SiteCategoryPage.vue?vue&type=template&id=15d588a8&scoped=true"
import script from "./SiteCategoryPage.vue?vue&type=script&lang=js"
export * from "./SiteCategoryPage.vue?vue&type=script&lang=js"

import "./SiteCategoryPage.vue?vue&type=style&index=0&id=15d588a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d588a8"]])

export default __exports__